import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { Observable } from "rxjs";
import { constants } from "../constants";
import { DashboardReviewData } from "../models/dashboard-review-data.model";
import { map } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class DashboardService {

    private static readonly DASHBOARD_URL = `${constants.BASE_URL}/dashboard`;

    constructor(private http: HttpClient) { }

    getDashboardReviewData(cpa: string): Observable<DashboardReviewData> {
        return this.http.get<DashboardReviewData>(`${DashboardService.DASHBOARD_URL}/${cpa}`)
            .pipe(map((response: any) => new DashboardReviewData(response)));
    }

    getCpas(): Observable<string[]> {
        return this.http.get<string[]>(`${DashboardService.DASHBOARD_URL}/cpas`);
    }

}